import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

// The SPA never reloads on its own, so a tab opened before a Publish keeps running the old bundle indefinitely.
// Poll index.html (no-store) and compare the hashed main bundle name with the one this tab is running.
const currentBundle = () => (document.querySelector('script[src*="/static/js/main."]')?.getAttribute("src") || "").split("/").pop();
const CHECK_MS = 60_000;

export const UpdateBanner = () => {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return;  // dev server (unhashed bundle.js): nothing to compare
    const check = async () => {
      try {
        const html = await (await fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" })).text();
        const served = (html.match(/static\/js\/(main\.[a-z0-9]+\.js)/) || [])[1];
        if (served && served !== mine) setStale(true);
      } catch { /* offline: try again next tick */ }
    };
    check();
    const t = setInterval(check, CHECK_MS);
    const onFocus = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", onFocus);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onFocus); };
  }, []);
  if (!stale) return null;
  return (
    <div data-testid="update-banner" className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-amber-400 text-black text-sm font-medium px-4 py-2">
      <RefreshCw size={15} /> A new version of the DME Processor was published. Reload to get the latest features.
      <button data-testid="update-reload-button" onClick={() => window.location.reload()} className="ml-2 px-3 h-8 rounded-sm bg-black text-amber-300 text-xs font-semibold hover:bg-slate-900">Reload now</button>
    </div>
  );
};
